import { ChatSocketService } from '@agent/agent-interface/contact-view/chat/services/chat-socket.service';
import { ChatStatsService } from '@agent/agent-interface/contact-view/chat/services/chat-stats.service';
import { Component, OnInit } from '@angular/core';
import UAParser from 'ua-parser-js';

import { BookingFacade, TranslateService } from '@contact/upgrade';

@Component({
  selector: 'chat-info',
  templateUrl: 'chat-info.component.html',
  styleUrls: ['./chat-info.component.scss'],
})
export class ChatInfoComponent implements OnInit {
  public readonly timerStatsName = ['timeOnCurrentPage', 'timeOnTheWebSite'];

  public isAuthenticated: boolean = false;

  responseId: string;

  statsInfo: any;
  formattedUA: string;
  isMobile: boolean = false;
  timerStatsInfo: Map<string, number> = new Map<string, number>();
  interactionDate: number = 0;

  constructor(
    private readonly chatStatsService: ChatStatsService,
    private readonly chatSocketService: ChatSocketService,
    private readonly contactFacade: BookingFacade,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit() {
    this.chatStatsService.visitorStatsChange$.subscribe(responseId => {
      if (responseId === this.responseId) {
        this.statsInfo = this.chatStatsService.getStatsMessage(this.responseId);
        if (this.statsInfo.userAgent && this.statsInfo.userAgent !== '') {
          const parsedUA = new UAParser(this.statsInfo.userAgent);
          const browser =
            parsedUA.getBrowser().name && parsedUA.getBrowser().version
              ? `${parsedUA.getBrowser().name}/${parsedUA.getBrowser().version}`
              : this.translateService.instant('agent:contact.workspace.chat.visitor_info.unknown_browser');
          const os =
            parsedUA.getOS().name && parsedUA.getOS().version
              ? `${parsedUA.getOS().name}/${parsedUA.getOS().version}`
              : this.translateService.instant('agent:contact.workspace.chat.visitor_info.unknown_os');
          this.formattedUA = `${this.translateService.instant(
            'agent:contact.workspace.chat.visitor_info.consulted_from'
          )} ${browser} - ${os}`;
          this.isMobile = parsedUA.getDevice().type === 'mobile';
        } else {
          this.formattedUA = `${this.translateService.instant(
            'agent:contact.workspace.chat.visitor_info.consulted_from'
          )} ${this.translateService.instant(
            'agent:contact.workspace.chat.visitor_info.unknown_browser'
          )} - ${this.translateService.instant('agent:contact.workspace.chat.visitor_info.unknown_os')}`;
        }
      }
    });
    setInterval(() => {
      this.updateTimerStatsInfo();
    }, 1000);

    this.contactFacade.selected$.subscribe(contact => {
      if (contact) {
        this.responseId = contact.responseId;
        this.statsInfo = this.chatStatsService.getStatsMessage(contact.responseId);
        this.isAuthenticated =
          !!contact.context && !!contact.context['userAuthenticationState'] && contact.context['userAuthenticationState'] === 'SUCCESS';
      }
    });
  }

  private updateTimerStatsInfo() {
    this.timerStatsName.forEach(name => {
      if (this.statsInfo && this.statsInfo[name] && !Number.isNaN(this.statsInfo[name])) {
        this.timerStatsInfo.set(name, Date.now() - +this.statsInfo[name]);
      } else {
        this.timerStatsInfo.set(name, 0);
      }
    });
    if (this.getFirstMessageDate() !== null) {
      this.interactionDate = Date.now() - this.getFirstMessageDate();
    }
  }

  private getFirstMessageDate(): number {
    return this.chatSocketService.getFirstMessageByVisitorByResponseId(this.responseId) || 0;
  }
}
